import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faSync, faCheck } from "@fortawesome/free-solid-svg-icons"
import {
	postSecteurs,
	postSecteursReset,
	deleteSecteur,
	deleteSecteurReset,
} from "../../../store/actions/autreActions"
import { COLORS } from "../../../utilities/Constants"
import { generalStyles as gs } from "../../styles/styles"
import CustomModal from "../../basics/interface/CustomModal"

// Édition d'un secteur (modal V2). POST/DELETE renvoient la liste fraîche →
// le reducer (autreInfo.secteurs) met la table à jour seul.
const SecteurModalV2 = ({ secteur, onClose }) => {
	const dispatch = useDispatch()
	const postState = useSelector((s) => s.autreInfo.postSecteurs)
	const deleteState = useSelector((s) => s.autreInfo.deleteSecteur)
	const isCreate = !secteur.id
	const [confirmDelete, setConfirmDelete] = useState(false)
	const [nom, setNom] = useState(secteur.nom || "")
	// Codes postaux du secteur (géo) : liste de chips éditable.
	const [codes, setCodes] = useState(
		(secteur.codes || []).map((c) => c.code),
	)
	const [codeInput, setCodeInput] = useState("")

	const addCode = () => {
		const c = codeInput.trim()
		if (c && !codes.includes(c)) setCodes((cs) => [...cs, c])
		setCodeInput("")
	}
	const removeCode = (code) => setCodes((cs) => cs.filter((c) => c !== code))

	// Fermeture après une sauvegarde OU une suppression réussie.
	useEffect(() => {
		if (!postState.saved && !deleteState.deleted) return
		const t = setTimeout(() => {
			dispatch(postSecteursReset())
			dispatch(deleteSecteurReset())
			onClose()
		}, 800)
		return () => clearTimeout(t)
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [postState.saved, deleteState.deleted])

	useEffect(
		() => () => {
			dispatch(postSecteursReset())
			dispatch(deleteSecteurReset())
		},
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[],
	)

	// Quitte le mode "confirmer" si la suppression échoue (secteur protégé).
	useEffect(() => {
		if (deleteState.error) setConfirmDelete(false)
	}, [deleteState.error])

	const invalid = !nom.trim()

	const save = () => {
		const payload = { id: secteur.id || null, nom: nom.trim(), codes }
		dispatch(postSecteurs(JSON.stringify({ 0: payload })))
	}
	const remove = () => {
		if (!confirmDelete) {
			setConfirmDelete(true)
			return
		}
		dispatch(deleteSecteur(JSON.stringify({ id: secteur.id })))
	}

	const busy =
		postState.saving ||
		postState.saved ||
		deleteState.deleting ||
		deleteState.deleted

	const buttons = []
	if (!isCreate) {
		buttons.push({
			title: deleteState.deleting ? (
				<FontAwesomeIcon icon={faSync} spin />
			) : confirmDelete ? (
				"Confirmer ?"
			) : (
				"Supprimer"
			),
			styleName: "danger",
			onClick: remove,
			disabled: busy,
		})
	}
	buttons.push({
		title: "Annuler",
		styleName: "secondary",
		onClick: onClose,
		disabled: busy,
	})
	buttons.push({
		title: postState.saving ? (
			<FontAwesomeIcon icon={faSync} spin />
		) : postState.saved ? (
			<FontAwesomeIcon icon={faCheck} />
		) : (
			"Enregistrer"
		),
		styleName: "primary",
		onClick: save,
		disabled: busy || invalid,
	})

	return (
		<CustomModal
			title={isCreate ? "Nouveau secteur" : "Éditer le secteur"}
			onClose={busy ? () => {} : onClose}
			showCloseButton={!busy}
			buttons={buttons}
		>
			<div style={gs.fieldGroup}>
				<div style={gs.fieldRow}>
					<label style={gs.label}>
						Nom<span style={{ color: COLORS.danger }}> *</span>
					</label>
					<input
						style={gs.input}
						value={nom}
						onChange={(e) => setNom(e.target.value)}
						autoFocus
					/>
				</div>
				<div style={{ ...gs.fieldRow, alignItems: "flex-start" }}>
					<label style={gs.label}>Codes postaux</label>
					<div style={{ flex: 1 }}>
						<div style={{ display: "flex", gap: 8 }}>
							<input
								style={gs.input}
								value={codeInput}
								placeholder="Ex. 1204"
								inputMode="numeric"
								onChange={(e) =>
									// Codes postaux = chiffres uniquement : on
									// retire tout caractère non numérique à la saisie.
									setCodeInput(
										e.target.value.replace(/\D/g, ""),
									)
								}
								onKeyDown={(e) => {
									if (e.key === "Enter" || e.key === ",") {
										e.preventDefault()
										addCode()
									}
								}}
							/>
							<button
								type="button"
								style={gs.btnSecondary}
								onClick={addCode}
								disabled={!codeInput.trim()}
							>
								Ajouter
							</button>
						</div>
						{codes.length > 0 && (
							<div
								style={{
									display: "flex",
									flexWrap: "wrap",
									gap: 6,
									marginTop: 10,
								}}
							>
								{codes.map((code) => (
									<span
										key={code}
										style={{
											display: "inline-flex",
											alignItems: "center",
											gap: 6,
											padding: "4px 10px",
											borderRadius: 99,
											backgroundColor: COLORS.accentLight,
											color: COLORS.accent,
											fontSize: 13,
											fontWeight: 500,
										}}
									>
										{code}
										<span
											onClick={() => removeCode(code)}
											style={{ cursor: "pointer", fontWeight: 700 }}
											title="Retirer"
										>
											×
										</span>
									</span>
								))}
							</div>
						)}
					</div>
				</div>
			</div>
		</CustomModal>
	)
}

export default SecteurModalV2
